import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

export interface NavigationButton {
  title: string;
  text: string;
  icon: string;
  route: string;
  isSelected: boolean;
  role?: string;
  order?: number;
}

@Injectable()
export abstract class NavigationButtonService {
  /**
   * Returns a list of all of the current user's todos.
   */
  abstract getButtons(): Observable<NavigationButton[]>;

  abstract getNavigationCommands(button: NavigationButton): any[];

  abstract onUrlChange(url: string, buttons: NavigationButton[]): NavigationButton[];
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/navigation-button/navigation-button.service.ts